import { useCallback } from "react";

import { formatNumber as formatNumberHelper } from "./helpers";

import { useGlobalSelector, userInfoSelector } from "core/stores/globalStore";
import { NUMBER_FORMAT } from "core/constants/format/numberFormat";

const useFormat = () => {
    const { formatSetting } = useGlobalSelector(userInfoSelector);

    const formatNumber = useCallback(num => {
        const numberFormatting = formatSetting?.numberFormatting ? formatSetting.numberFormatting : NUMBER_FORMAT.FORMAT_1;
        return formatNumberHelper(num, numberFormatting)
    }, [formatSetting])

    return {
        formatNumber
    }
}

export default useFormat;